// import Vue from 'vue'
import { createApp } from 'vue'
import { store } from './router/store'
import App from './App.vue'
import router from './router/router'
import axios from './actions/axios-actions'
import VueAxios from './actions/axios-actions'
import VueMeta from 'vue-meta'
import VueMatomo from 'vue-matomo'
import AOS from 'aos';
import 'aos/dist/aos.css';
import Toast from "vue-toastification";
import i18n from "./locales/i18n"
import moment from 'moment'
import { useI18n } from 'vue-i18n'; 
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";


import 'bootstrap'
import './assets/css/app.scss'

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'


window.axeptioSettings = {
  clientId: "60cb5d33738e6c44694e0c43",
  cookiesVersion: "agrivitech-base",
};
 
(function(d, s) {
  var t = d.getElementsByTagName(s)[0], e = d.createElement(s);
  e.async = true; e.src = "//static.axept.io/sdk.js";
  t.parentNode.insertBefore(e, t);
})(document, "script");


const app = createApp(App);

app.use(router, store, axios, VueAxios, AOS.init(), VueMeta)
app.use(Toast, { timeout: 4000})
app.use(VueMatomo, {
  host: 'https://staging-matomo.digitappro.io',
  siteId: 9,
  router: router,
  enableLinkTracking: true,
  requireConsent: false,
  trackInitialView: true,
  disableCookies: false,
  requireCookieConsent: false,
  enableHeartBeatTimer: true,
  heartBeatTimerInterval: 5,
  trackerFileName: 'matomo',
  trackerUrl: undefined,
  trackerScriptUrl: undefined,
  debug: true,
  userId: undefined,
  preInitActions: []
})
app.use(i18n, {useI18n})
app.use(moment)
app.mount('#app');

